import { ListResult } from '@shared/api';
import { Api } from '../../Api';
import { IServiceAchRelationshipsDto } from './interfaces';
import { IServiceAchRelationshipsGetQuery } from './query';

export class AchRelationships {
    private static _basePath = '/ach/relationships';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${AchRelationships._basePath}`;
        return {
            async get(query: IServiceAchRelationshipsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<IServiceAchRelationshipsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
